module.exports = __webpack_public_path__ + "img/paper-head.72c2042d.png";